<template>
  <div class="create-customer-drawer"
       v-if="drawer">
    <el-drawer :title="title"
               :visible.sync="drawer"
               :wrapperClosable="false"
               :close-on-press-escape="false"
               direction="rtl"
               @close="colseDrawer">
      <div class="base">
        <div class="add-item-title"
             style="margin-top: 0">基本信息</div>
        <el-form ref="form"
                 :inline="true"
                 :model="form"
                 :rules="rules"
                 label-width="80px"
                 size="mini"
                 v-enterToNext="true">
          <el-form-item label="计划名称"
                        prop="projectName">
            <el-input v-model="form.projectName"
                      maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="计划编号">
            <el-input v-model="form.projectNumber"
                      @input="filterProjectNumber"
                      maxlength="20"></el-input>
          </el-form-item>

          <el-row>
            <el-form-item label="计划生效"
                          prop="dateTimeFrom">
              <el-date-picker v-model="form.dateTimeFrom"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              :picker-options="startDatePickerOptions"
                              @change="handleDateChange"></el-date-picker>
            </el-form-item>

            <el-form-item label="计划结束">
              <el-date-picker v-model="form.dateTimeTo"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              :picker-options="endDatePickerOptions"
                              @change="handleDateChange"></el-date-picker>
            </el-form-item>

            <el-form-item label="公共计划">
              <el-checkbox v-model="form.isPublic">是</el-checkbox>
            </el-form-item>
          </el-row>

          <el-form-item label="选择职位">
            <el-select filterable
                       v-model="form.entryPositionId"
                       ref="entryPositionId"
                       clearable
                       multiple
                       @change="addPosition"
                       placeholder="请选择职位（可多选）">
              <el-option v-for="item in positionList"
                         :key="item.id"
                         :label="item.positionName + '（' + item.enterpriseShortName + '）'"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <div style="float: right; margin-bottom: 10px;">
            <el-button size="mini"
                       icon="el-icon-delete"
                       @click="deletePosition"
                       type="primary"
                       plain>删除</el-button>
          </div>

          <MyTable :tableData="tableData"
                   :tableConfig="tableConfig"
                   height="400px"
                   tableType="selection"
                   @selectionChange="selectionChange"
                   :indexFlag="true">
            <template v-slot:index="slotData">
              {{ slotData.scope.$index + 1 }}
            </template>
          </MyTable>
        </el-form>
      </div>
      <div class="rightPadding"></div>

      <div class="submit-bar">
        <el-button @click="
            () => {
              colseDrawer();
            }
          ">取 消</el-button>
        <el-button type="primary"
                   :loading="submitLoading"
                   @click="onSubmit">保 存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import MyTable from "@/components/Table";

export default {
  components: {
    MyTable,
  },
  props: {
    users: Array,
    title: String,
    drawerShow: Boolean,
    operation: String,
    customerInfo: Object,
  },
  data () {
    return {
      submitLoading: false,
      drawer: false,
      companyScale: [],
      form: {
        projectStatus: "未发布",
        isPublic: true,
        entryPositionId: [], // 初始为空数组
      },
      startDatePickerOptions: {
        disabledDate: (date) => {
          if (!this.form.dateTimeTo) return false;
          const endDate = new Date(this.form.dateTimeTo);
          endDate.setHours(0, 0, 0, 0);
          return date.getTime() >= endDate.getTime();
        },
      },
      endDatePickerOptions: {
        disabledDate: (date) => {
          if (!this.form.dateTimeFrom) return false;
          const startDate = new Date(this.form.dateTimeFrom);
          startDate.setHours(0, 0, 0, 0);
          return date.getTime() <= startDate.getTime();
        },
      },
      rules: {
        projectName: [{ required: true, message: "请输入计划名称", trigger: "blur" }],
        dateTimeFrom: [{ required: true, message: "请选择计划生效", trigger: "blur" }],
        dateTimeTo: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
        projectStatus: [{ required: true, message: "请选择发布状态", trigger: "blur" }],
      },
      positionList: [],
      tableData: [],
      AllpositionList: [],
      flagId: 0,
      idList: [],
      tableConfig: [
        {
          field: "enterpriseShortName",
          label: "企业简称",
          flag: true,
          align: "center",
        },
        {
          field: "positionName",
          label: "职位名称",
          flag: true,
          align: "center",
        },
        {
          field: "recruitingNum",
          label: "招聘人数",
          flag: true,
          align: "center",
        },
      ],
    };
  },
  created () { },
  methods: {
    handleDateChange () {
      const { dateTimeFrom, dateTimeTo } = this.form;
      if (dateTimeFrom && dateTimeTo) {
        const start = new Date(dateTimeFrom);
        const end = new Date(dateTimeTo);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        if (start >= end) {
          this.form.dateTimeTo = "";
        }
      }
    },
    filterProjectNumber () {
      if (this.form.projectNumber) {
        this.form.projectNumber = this.form.projectNumber.replace(/[^0-9a-z]/g, "");
      }
    },
    deletePosition () {
      if (this.operation == "edit") {
        this.$confirm("此操作将同步删除职位管理的数据！, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let sendData = this.idList;
            this.$api.PositionInfo.Delete(sendData).then((res) => {
              if (res.error === false) {
                this.getPosList();
                this.PositionList()
              }
            });
          })
          .catch(() => { });
      } else {
        this.tableData = this.tableData.filter((v) => {
          return !this.idList.includes(v.id);
        });
        this.positionList = this.filterUniquePositions();
      }
    },
    getPosList () {
      let sendData = {
        page: 1,
        pageSize: -1,
        fkValue: this.customerInfo.id,
      };
      this.$api.PositionInfo.ListProjectPosition(sendData).then((res) => {
        if (res.error === false) {
          this.tableData = res.data;
        }
      });
    },
    selectionChange (selection) {
      this.idList = selection.map((v) => {
        return v.id;
      });
    },
    addPosition (values) {
      if (!values || values.length === 0) return;
      values.forEach((value) => {
        let position = this.positionList.find((item) => item.id === value);
        if (position && !this.tableData.some((item) => item.id === position.id)) {
          this.tableData.push(position);
        }
      });
      this.form.entryPositionId = [];
      this.positionList = this.filterUniquePositions();
    },
    filterUniquePositions () {
      const existingIds = new Set(this.tableData.map((item) => item.id));
      const filteredList = this.AllpositionList.filter((item) => !existingIds.has(item.id));
      return filteredList;
    },
    async PositionList () {
      let sendData = {
        page: 1,
        pageSize: -1,
      };
      const res = await this.$api.PositionInfo.ListDistinct(sendData);
      if (res.error === false) {
        this.AllpositionList = res.data;
        this.positionList = this.filterUniquePositions();
        // 编辑模式强制清空选择框
        if (this.operation === 'edit' && this.drawer) {
          this.form.entryPositionId = [];
        }
      }
    },
    validateForm (formName) {
      return new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async onSubmit () {
      const isValid = await this.validateForm("form");
      if (!isValid) {
        this.$message.warning("填写信息有误，请检查表单");
        return;
      }
      if (this.tableData.length === 0) {
        this.$message({
          message: "请添加计划的职位！",
          type: "warning",
        });
        return;
      }
      this.submitLoading = true;
      let sendData = this.form;
      sendData.positionList = this.tableData;
      this.$api.ProjectInfo[this.operation == "edit" ? "Modify" : "Create"](sendData).then(
        (res) => {
          if (res.error === false) {
            this.$message.success("保存成功");
            this.$emit("refreshData");
          }
          this.submitLoading = false;
          this.colseDrawer();
        }
      );
    },
    colseDrawer () {
      this.$emit("colseDrawer");
    },
    fillFormData (Info) {
      this.form = {
        ...Info,
        entryPositionId: [], // 强制清空，不回显
      };
      this.$set(this.form, "dateRange", [Info.dateTimeFrom, Info.dateTimeTo]);
      this.tableData = Info.positionList || [];
      // 完全移除回显逻辑
    },
  },
  watch: {
    drawerShow (val) {
      this.PositionList();
      if (val) {
        this.$nextTick(() => {
          if (this.$refs["form"]) {
            this.$refs["form"].clearValidate();
          }
          // 额外保险：编辑模式下清空选择框
          if (this.operation === 'edit') {
            this.form.entryPositionId = [];
          }
        });
      }
      this.drawer = val;
      if (this.drawer == false) {
        this.form = {
          projectStatus: "未发布",
          isPublic: true,
          entryPositionId: [],
        };
        this.tableData = [];
        this.idList = [];
        return;
      }
      if (this.operation == "edit") {
        this.fillFormData(this.customerInfo);
      }
    },
  },
};
</script>

<style lang="less">
.create-customer-drawer {
  .el-drawer {
    width: 78% !important;
    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  .add-item-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .base {
    width: 80%;
    float: left;
    padding: 17px 20px 60px 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;
    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 54%;
      }
      .el-select {
        width: 100%;
      }
    }
  }
  .rightPadding {
    width: 20%;
    height: 100%;
    float: right;
  }
  .submit-bar {
    position: absolute;
    z-index: 99999;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 0;
    background-color: #fff;
    text-align: center !important;
    border-top: 1px solid #ddd;
    padding-right: 20px;
    .el-button {
      padding: 8px 20px;
    }
  }
}
</style>